import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { setOLI } from '~/common/redux/actions';

export type ObfuscatedLoanIdentifier = NonNullable<
  ReturnType<typeof useUrl>['obfuscatedLoanIdentifier']
>;

const pattern =
  /^\/(?<obfuscatedLenderDatabaseId>\d+)\/(?<obfuscatedLoanRecordId>\d+)/;

export default function useUrl() {
  const dispatch = useDispatch();

  const obfuscatedLoanIdentifier = useMemo(() => {
    const match = pattern.exec(globalThis.location.pathname);
    if (!match) {
      return null;
    }

    const { obfuscatedLenderDatabaseId, obfuscatedLoanRecordId } = match.groups;

    return {
      obfuscatedLenderDatabaseId: Number.parseInt(obfuscatedLenderDatabaseId),
      obfuscatedLoanRecordId: Number.parseInt(obfuscatedLoanRecordId),
    };
  }, []);

  // temporary data sync for thunks and class components
  useEffect(() => {
    if (!obfuscatedLoanIdentifier) {
      return;
    }

    dispatch(
      setOLI(
        obfuscatedLoanIdentifier.obfuscatedLenderDatabaseId,
        obfuscatedLoanIdentifier.obfuscatedLoanRecordId,
      ),
    );
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [obfuscatedLoanIdentifier]);

  const isReadOnly = globalThis.location.pathname.includes('/readOnly');

  return { obfuscatedLoanIdentifier, isReadOnly };
}
